import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex',
    text: '',
    button:
      'hover:text-blue h-fit p-0 hover:border-transparent hover:bg-transparent'
  },
  variants: {},
  defaultVariants: {}
});
